exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "table {\n  table-layout: fixed;\n}\n\ntable th, table td {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/developer/Downloads/SleepRestoreBackend/sleep-restore-boot/src/main/ngapp/src/app/questionnaires/questionnaires.component.css
// module id = ../../../../../src/app/questionnaires/questionnaires.component.css
// module chunks = main